var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_setting-2",
    "data-name": "vuesax/bulk/setting-2",
    transform: "translate(-300 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2",
    transform: "translate(300 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,8.679V7.2A1.611,1.611,0,0,1,1.615,5.6c1.539,0,2.168-1.077,1.394-2.4a1.588,1.588,0,0,1,.6-2.178L5.075.193A1.427,1.427,0,0,1,7.013.7l.094.16c.765,1.321,2.023,1.321,2.8,0L10,.7a1.427,1.427,0,0,1,1.938-.5l1.471.833A1.588,1.588,0,0,1,14,3.2c-.774,1.321-.145,2.4,1.394,2.4A1.611,1.611,0,0,1,17.01,7.2v1.48a1.611,1.611,0,0,1-1.615,1.6c-1.539,0-2.168,1.077-1.394,2.4a1.586,1.586,0,0,1-.6,2.178l-1.471.833a1.427,1.427,0,0,1-1.938-.5l-.094-.16c-.765-1.321-2.023-1.321-2.8,0l-.094.16a1.427,1.427,0,0,1-1.938.5L3.6,14.853a1.588,1.588,0,0,1-.6-2.178c.774-1.321.145-2.4-1.394-2.4A1.611,1.611,0,0,1,0,8.679Z",
    transform: "translate(2 2.561)",
    fill: "#191919",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H21V21H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.5,3.25A3.25,3.25,0,1,1,3.25,0,3.25,3.25,0,0,1,6.5,3.25Z",
    transform: "translate(7.255 7.25)",
    fill: "#191919"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.5b4d8e6a7f55c9a563b9e630ded337a7.svg";
export { ForwardRef as ReactComponent };